$ ->
  $('.scrollspy').each ->
    target = $(this).attr('id')
    lineHeight = $(this).find('li').height()
    $("##{target}").data 'defaultTop', $("##{target}").offset().top

    $($(this).data('target')).scrollspy
      target: "##{target}"
      offset: $(this).data('offset')

    topElementsHeight = $('#header_bar').height() +
      $('#top_navigation').height() + $('.alert.alert-info').outerHeight() +
      $('.page-header').outerHeight(true)

    setNavHeight = ->
      maxHeight = $(window).height() - topElementsHeight - (lineHeight * 2)

      lineMultipleAdjustedHeight = maxHeight - (maxHeight %% lineHeight)
      $("##{target}").css 'height', lineMultipleAdjustedHeight+'px'

    setNavPosition = ->
      defaultNavTop = $("##{target}").data().defaultTop
      headerSpace = $('.page-header').outerHeight(true) + $('.alert.alert-info').outerHeight()
      isNavScrollable = $("##{target}").children('.nav.sidenav').height() > $("##{target}").height()

      if ($(window).scrollTop() > $('.alert.alert-info').outerHeight()) && isNavScrollable
        addedHeight = headerSpace/1.5
        $("##{target}").css('top', defaultNavTop - addedHeight)
      else
        $("##{target}").css('top', defaultNavTop)

    setNavHeight()

    $(this).on 'activate.bs.scrollspy', ->
      activeItem = $(this).find('li.active')
      index = activeItem.index()

      unless ($(this).is(':hover'))
        offset = index * lineHeight
        $(this).scrollTop(offset);

    $(window).resize setNavHeight
    $(window).scroll setNavPosition
